import axios from "axios";
import {BACK_OFFICE_API, LOGIN_API} from "../../../constants/apiUrls"
// 아이디 중복체크
export const idCheck = async (id) => {
  let result = await axios.post(`${LOGIN_API}/user/id/check`, {
    channelType: 2,
    loginId: id
  })

  return result.data;
}


// 비밀번호 변경
export const pwChange = (userId, data, token) => {
  axios.put(`${LOGIN_API}/user/password/${userId}`, data, {
    headers: {Authorization: `Bearer ${token}`}
  }).then(() => {
    alert("비밀번호가 변경되었습니다.");
    window.location.reload();
  })
}

// 로그인
export const loginApi = async (loginId, loginPw, keepChk) => {
  try {
    const loginInfo = await axios.post(`${LOGIN_API}/login`, {
      channelType: 2,
      loginId: loginId,
      loginPassword: loginPw,
      loginDeviceType: 2,
      version: "1.0.0"
    });

    const { userId, token } = loginInfo.data;

    loginInfoSaveApi(userId, token, keepChk);
  } catch (e) {
    alert("일치하는 회원정보가 없습니다.");
  }
}

// 토큰 로그인
export const tokenLoginApi = async (userId, userType, token, url) => {
  try {
    const loginInfo = await axios.post(`${LOGIN_API}/login/token`, {
      channelType: 1,
      userType: userType,
      userId: userId,
      loginDeviceType: 2,
      version: "1.0.0"
    }, {
      headers: {Authorization: `Bearer ${token}`}
    });

    const { userId: posUserId, token: posToken } = loginInfo.data;

    tokenConvertApi(posUserId, userType, posToken, url);

  } catch (e) {
    alert("일치하는 회원정보가 없습니다.");
  }
}

// 토큰 전환
export const tokenConvertApi = async (userId, userType, token, url) => {
  try {
    const loginInfo = await axios.post(`${LOGIN_API}/login/token/convert`, {
      fromChannelType: 1,
      toChannelType: 2,
      userType: userType,
      userId: userId
    }, {
      headers: {Authorization: `Bearer ${token}`}
    });

    loginInfoSaveApi(loginInfo.data.userId, loginInfo.data.token, false, url);

  } catch (e) {
    alert("일치하는 회원정보가 없습니다.");
  }
}

// 회원정보 세션에 저장
export const loginInfoSaveApi = async (userId, token, keepChk, url) => {
  const userInfo = await axios.get(`${BACK_OFFICE_API}/shop/${userId}`);
  const { shopTp, reptName } = userInfo.data[0];

  const storage = keepChk ? window.localStorage : window.sessionStorage;

  storage.setItem("userId", userId);
  storage.setItem("token", token);
  storage.setItem("userType", shopTp);
  storage.setItem("reptName", reptName);

  if(keepChk) {
    storage.setItem("keepChk", keepChk)
  }

  if(url) {
    window.location.href = url;
  } else {
    window.location.href = "/v2/shopInfo1";
  }
}

// 서비스 유형 변경
export function formatService(service) {
  const serviceList = ["배달/포장", "전통시장", "", "", "", "택배배송"]
  let formatService = "";

  if(service) {
    formatService = serviceList[service - 1];
  }

  return formatService;
}